import mutations from './mutations';
import getters from './getters';

const state = {
  error: {},
  status: 0,
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
};
